<template>
  <tr>
    <td
      class="fixed fixed-add stripe_green"
      style="border: none !important"
    ></td>
    <td
      class="fixed fixed01 show-workpattern"
      style="text-align: center"
    >
      {{ header }}
    </td>
    <td
      class="fixed fixed02 summary-row-todal show-total"
      style="left: 306px"
    >
      {{ total }}
    </td>
    <td
      v-for="(val, index) of list"
      :key="index"
    >
      {{ val }}
    </td>
  </tr>
</template>

<script>
export default {
  name: 'RowTemplate',
  props: {
    header: {
      type: String,
      required: true,
      default: '',
    },
    total: {
      type: String,
      default: '',
    },
    list: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
};
</script>
